import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'

import { isTabletOrSmallDesktopQuery } from '../../utils'
import EventCard from './EventCard'
import { RootState } from '../../store'
import { IEvent } from '../../store/events/interfaces'
import { getFilteredEvents } from '../../store/events/selectors'
import { EventListTable } from './EventListTable'
import { getEventsByWeek } from '../../functions/events/eventsByWeek'

const EventList: React.FC = () => {
  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations,
  )
  const events = useSelector(getFilteredEvents)
  const [eventsByWeek, maxDate] = getEventsByWeek(events)
  const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery)

  return (
    <>
      {events.length > 0 ? (
        <>
          {isTabletOrSmallDesktop ? (
            <div
              className='mt-3'
              role='region'
              aria-label='Liste aller Veranstaltungen'
            >
              {Object.entries(eventsByWeek)
                .filter(([_weekId, events]) => events.length > 0)
                .sort(([weekIdA, _a], [weekIdB, _b]) => weekIdA.localeCompare(weekIdB))
                .map(([weekId, events]) => {
                  const weekStart = moment(weekId, 'YYYY;WW')
                  return (
                    <div key={weekId}>
                      <Row>
                        <Col
                          md={12}
                          sm={12}
                          className='text-center font-weight-bold'
                        >
                          <div className='bg-light w-100 border-bottom border-top py-2'>
                            {weekId === maxDate
                              ? 'Veranstaltungen ohne Zeitraum'
                              : `KW ${weekStart.isoWeek()} vom ${weekStart.format(
                                'DD.MM.',
                              )} bis zum ${weekStart
                                .add(7, 'days')
                                .format('DD.MM.')}`}
                          </div>
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        {events.map((event: IEvent) => (
                          <Col key={event.event_id} md={6} sm={12} className='p-3'>
                            <EventCard
                              event={event}
                              hasRegistration={registrations.some(
                                reg => reg.event?.event_id === event.event_id,
                              )}
                            />
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )
                })}
            </div>
          ) : (
            <EventListTable />
          )}
        </>
      ) : (
        <Row>
          <Col md={{ span: 6, offset: 3 }} className='mt-3'>
            Aktuell sind keine Veranstaltungen für dieses Programm und gewählte Filter vorhanden.
          </Col>
        </Row>
      )}
    </>
  )
}

export default EventList
